/* eslint-disable no-unused-vars */
const CREATOR = 'CREATOR';
const MANAGER = 'MANAGER';
const SCREENING_ACCEPT = 'SCREENING_ACCEPT';
const SCREENING_REJECT = 'SCREENING_REJECT';
const ATTENDEE_CHECK_IN = 'ATTENDEE_CHECK_IN';
const ATTENDEE_CHECK_OUT = 'ATTENDEE_CHECK_OUT';
/* eslint-enable */

export const EVENT_CREATOR = CREATOR;
export const EVENT_MANAGER = MANAGER;
export const CAN_SCREENING = {
  $or: [
    CREATOR,
    { $and: [SCREENING_ACCEPT, SCREENING_REJECT] }
  ]
};

export const CAN_CHECKIN_CHECKOUT = {
  $or: [
    CREATOR,
    MANAGER,
    { $and: [ATTENDEE_CHECK_IN, ATTENDEE_CHECK_OUT] }
  ]
};



// WEBPACK FOOTER //
// ./src/components/permission/constants/permissions.js